import commPreferencesRepository from '@/repositories/comm-preferences.repository';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useGetCommPreferences() {
  return useQuery({
    queryKey: ['comm-preferences', 'get'],
    queryFn: commPreferencesRepository.get,
  });
}

export function useUpdateCommPreferences() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: commPreferencesRepository.updateCommPreferences,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['comm-preferences', 'get'] });
    },
  });
}
